export default __webpack_public_path__ + "static/1994-05-01_effect_JASA.pdf";